import "./App.css";
import { Route, Routes, useLocation } from "react-router-dom";
import Home from "./components/pages/home/Home";
import Product from "./components/pages/product/Product";
import Category from "./components/pages/category/Category";
import NoMatch from "./components/NoMatch";
import Login from "./components/pages/login/Login";
import Register from "./components/pages/register/Register";
import Cart from "./components/cart/Cart";
import About from "./components/pages/about/About";
import Navbar from "./components/Navbar";
import { useState } from "react";
import Checkout from "./components/pages/checkout/Checkout";
import Footer from "./components/Footer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProtectedRoute from "./components/ProtectedRoute";
import { useSelector } from "react-redux";
import Orders from "./components/pages/orders/Orders";
import UserProfile from "./components/pages/userprofile/UserProfile";

function App() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const currentPage = useLocation();
  const pagesWithoutNavbar = ["/login", "/register"];
  const pagesWithoutFooter = ["/login", "/register"];
  const user = useSelector((state) => state.user);

  return (
    <div className="App">
      {!pagesWithoutNavbar.includes(currentPage.pathname) && (
        <Navbar handleShow={handleShow} user={user.info} />
      )}
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Home />} />
        <Route path="/register" element={<Register />} />
        <Route path="/about" element={<About />} />
        <Route path="/category/:name" element={<Category />} />
        <Route
          path="/product/:product_slug"
          element={<Product handleShow={handleShow} />}
        />
        <Route element={<ProtectedRoute user={user.info} />}>
          <Route path="/orders" element={<Orders />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/profile" element={<UserProfile />} />
        </Route>

        <Route path="*" element={<NoMatch />} />
      </Routes>
      <Cart show={show} handleClose={handleClose} />
      {!pagesWithoutFooter.includes(currentPage.pathname) && <Footer />}
    </div>
  );
}

export default App;
